import { StepAction } from './stepAction';
import type { TextValidationStep } from 'clickim/src/common/models/textValidationStep';

export class TextValidationStepAction extends StepAction<TextValidationStep> {
    override async performAction() {
        const { step, context, sessionPlayerInit: { stepParamExpressionEvaluator: paramEvaluator, utils, commonConstants } } = this;
        const target = this.getTarget();

        try {
            const actual = await this.stepActionUtils.extractTargetText(target);
            const { evaluatedText: expected } = paramEvaluator.computeExpression(step.expression2!, context, this.exportsGlobal, this.exportsTest);
            try {
                const compareResult = utils.compareOrMatch(expected, actual);
                if (compareResult) {
                    return { success: true };
                }
                return {
                    success: false,
                    errorType: commonConstants.stepResult.TEXT_COMPARE_FAILURE,
                    resultInfo: { expected: String(expected), actual },
                };
            } catch (err) {
                return {
                    success: false,
                    errorType: commonConstants.stepResult.TEXT_COMPARE_FAILURE,
                    resultInfo: { expected: expected.toString(), actual },
                };
            }
        } catch (err) {
            return {
                success: false,
                reason: err.message,
                exception: err,
                shouldRetry: true,
            };
        }
    }
}
